class Workshop3Activite4CsvGenerator {
  constructor(data, lang = "fr") {
    this.data = data || {};
    this.measures = this.data.measures || [];
    this.residualRisks = this.data.residualRisks || [];
    this.organizationName = this.data.organizationName || "Organization";
    this.lang = lang;
    this.labels = lang === "en" ? this.getEnLabels() : this.getFrLabels();
  }

  getFrLabels() {
    return {
      title: "ATELIER 3 - ACTIVITÉ 4 : MESURES ÉCOSYSTÈME",
      measures: "MESURES DE SÉCURITÉ ÉCOSYSTÈME",
      residualRiskSection: "RISQUE RÉSIDUEL PAR PARTIE PRENANTE",
      stakeholderName: "Partie Prenante",
      initialRisk: "Risque Initial",
      initialZone: "Ancienne Zone",
      residualRisk: "Risque Résiduel",
      residualRiskExpression: "Expression du risque résiduel",
      residualZone: "Nouvelle Zone",
      reduction: "Réduction (%)",
      name: "Nom de la mesure",
      category: "Catégorie",
      status: "Statut",
      priority: "Priorité",
      responsible: "Responsable",
      effD: "Efficacité (Dépendance)",
      effP: "Efficacité (Pénétration)",
      effM: "Efficacité (Maturité)",
      effC: "Efficacité (Confiance)",
      cost: "Coût",
      description: "Description",
      sourceRisks: "Risques Sources",
      objectives: "Objectifs Visés",
      governance: "Gouvernance",
      protection: "Protection",
      defense: "Défense",
      resilience: "Résilience",
      other: "Autre",
      high: "Haute",
      medium: "Moyenne",
      low: "Basse",
      planned: "Planifiée",
      inProgress: "En cours",
      implemented: "Implémentée",
      abandoned: "Abandonnée",
      noMeasures: "Aucune mesure écosystème définie",
      noResidualRisks: "Aucune donnée de risque résiduel disponible",
    };
  }

  getEnLabels() {
    return {
      title: "WORKSHOP 3 - ACTIVITY 4: ECOSYSTEM MEASURES",
      measures: "ECOSYSTEM SECURITY MEASURES",
      residualRiskSection: "RESIDUAL RISK PER STAKEHOLDER",
      stakeholderName: "Stakeholder",
      initialRisk: "Initial Risk",
      initialZone: "Old Zone",
      residualRisk: "Residual Risk",
      residualRiskExpression: "Residual Risk Expression",
      residualZone: "New Zone",
      reduction: "Reduction (%)",
      name: "Measure Name",
      category: "Category",
      status: "Status",
      priority: "Priority",
      responsible: "Responsible",
      effD: "Effectiveness (Dependency)",
      effP: "Effectiveness (Penetration)",
      effM: "Effectiveness (Maturity)",
      effC: "Effectiveness (Trust)",
      cost: "Cost",
      description: "Description",
      sourceRisks: "Source Risks",
      objectives: "Target Objectives",
      governance: "Governance",
      protection: "Protection",
      defense: "Defense",
      resilience: "Resilience",
      other: "Other",
      high: "High",
      medium: "Medium",
      low: "Low",
      planned: "Planned",
      inProgress: "In Progress",
      implemented: "Implemented",
      abandoned: "Abandoned",
      noMeasures: "No ecosystem measures defined",
      noResidualRisks: "No residual risk data available",
    };
  }

  createSectionHeader(title, colspan = 12) {
    return `<tr><td colspan="${colspan}" style="background-color: #1E40AF; color: white; font-weight: bold; font-size: 14px; padding: 10px 8px;">${title}</td></tr>`;
  }

  createTableHeader(headers) {
    return `<tr>
            ${headers.map((h) => `<td style="background-color: #3B82F6; color: white; font-weight: bold; padding: 8px; border: 1px solid #93C5FD;">${h}</td>`).join("")}
        </tr>`;
  }

  createDataRow(cells) {
    return `<tr>
            ${cells.map((c) => `<td style="padding: 6px 8px; border: 1px solid #E2E8F0; vertical-align: top;">${c || ""}</td>`).join("")}
        </tr>`;
  }

  getCategoryText(category) {
    const catMap = {
      governance: this.labels.governance,
      protection: this.labels.protection,
      defense: this.labels.defense,
      resilience: this.labels.resilience,
      other: this.labels.other,
    };
    return catMap[category] || category;
  }

  getCategoryColor(category) {
    const colorMap = {
      governance: "background-color: #DBEAFE; color: #1E40AF;",
      protection: "background-color: #DCFCE7; color: #166534;",
      defense: "background-color: #EDE9FE; color: #5B21B6;",
      resilience: "background-color: #FEF9C3; color: #854D0E;",
      other: "background-color: #F1F5F9; color: #475569;",
    };
    return colorMap[category] || "background-color: #F1F5F9; color: #475569;";
  }

  getStatusText(status) {
    const statusMap = {
      planned: this.labels.planned,
      "in-progress": this.labels.inProgress,
      implemented: this.labels.implemented,
      abandoned: this.labels.abandoned,
    };
    return statusMap[status] || status;
  }

  getStatusColor(status) {
    const colorMap = {
      planned: "background-color: #DBEAFE; color: #1E40AF;",
      "in-progress": "background-color: #FEF9C3; color: #854D0E;",
      implemented: "background-color: #DCFCE7; color: #166534;",
      abandoned: "background-color: #FEE2E2; color: #991B1B;",
    };
    return colorMap[status] || "background-color: #F1F5F9; color: #475569;";
  }

  getPriorityText(priority) {
    const priorityMap = {
      high: this.labels.high,
      medium: this.labels.medium,
      low: this.labels.low,
    };
    return priorityMap[priority] || priority;
  }

  getPriorityColor(priority) {
    const colorMap = {
      high: "background-color: #FEE2E2; color: #991B1B;",
      medium: "background-color: #FEF9C3; color: #854D0E;",
      low: "background-color: #DCFCE7; color: #166534;",
    };
    return colorMap[priority] || "background-color: #F1F5F9; color: #475569;";
  }

  generateMeasuresSection() {
    if (!this.measures || this.measures.length === 0) {
      return (
        this.createSectionHeader(this.labels.measures) +
        `<tr><td colspan="12" style="padding: 8px; color: #6B7280; font-style: italic;">${this.labels.noMeasures}</td></tr>`
      );
    }

    const headers = [
      this.labels.name,
      this.labels.category,
      this.labels.priority,
      this.labels.status,
      this.labels.responsible,
      this.labels.sourceRisks,
      this.labels.objectives,
      this.labels.effD,
      this.labels.effP,
      this.labels.effM,
      this.labels.effC,
      this.labels.description,
    ];

    const rows = this.measures
      .map((m) => {
        const categoryColor = this.getCategoryColor(m.category);
        
        // Fix: Use m.implementation (which is what Activite4 uses) instead of m.implementationStatus
        const statusValue = m.implementation || m.implementationStatus;
        const statusColor = this.getStatusColor(statusValue);
        const statusText = this.getStatusText(statusValue);
        
        const priorityColor = this.getPriorityColor(m.priority);
        const getSafeText = (arr) => {
          if (Array.isArray(arr)) {
            return arr
              .map((item) => {
                if (item && typeof item === "object") {
                  return (
                    item.name ||
                    item.title ||
                    item.reference ||
                    item.objectifVise ||
                    item.id ||
                    JSON.stringify(item)
                  );
                }
                return String(item);
              })
              .filter(Boolean)
              .join(", ");
          }
          if (arr && typeof arr === "object") {
            return arr.name || arr.title || JSON.stringify(arr);
          }
          return arr ? String(arr) : "";
        };

        const sourceRisksText = getSafeText(m.sourceRisks);
        const objectivesText =
          m.objectifsVises &&
          Array.isArray(m.objectifsVises) &&
          m.objectifsVises.length > 0
            ? getSafeText(m.objectifsVises)
            : getSafeText(m.objectives);

        const getTitle = (t) => {
          if (typeof t === "string") return t;
          if (t && typeof t === "object")
            return t.fr || t.en || t.name || JSON.stringify(t);
          return "";
        };
        const measureTitle = getTitle(m.title || m.name);
        
        return this.createDataRow([
          `<strong>${measureTitle}</strong>`,
          `<span style="${categoryColor} padding: 2px 6px; border-radius: 4px;">${this.getCategoryText(m.category)}</span>`,
          `<span style="${priorityColor} padding: 2px 6px; border-radius: 4px;">${this.getPriorityText(m.priority)}</span>`,
          `<span style="${statusColor} padding: 2px 6px; border-radius: 4px;">${statusText}</span>`,
          m.responsibleParty || "",
          sourceRisksText,
          objectivesText,
          m.dependanceEffectiveness ? `-${m.dependanceEffectiveness}` : "0",
          m.penetrationEffectiveness ? `-${m.penetrationEffectiveness}` : "0",
          m.maturiteCyberEffectiveness ? `+${m.maturiteCyberEffectiveness}` : "0",
          m.confianceEffectiveness ? `+${m.confianceEffectiveness}` : "0",
          m.description || "",
        ]);
      })
      .join("");

    return (
      this.createSectionHeader(this.labels.measures) +
      this.createTableHeader(headers) +
      rows
    );
  }

  generateResidualRiskSection() {
    if (!this.residualRisks || this.residualRisks.length === 0) {
      return (
        this.createSectionHeader(this.labels.residualRiskSection, 7) +
        `<tr><td colspan="7" style="padding: 8px; color: #6B7280; font-style: italic;">${this.labels.noResidualRisks}</td></tr>`
      );
    }

    const headers = [
      this.labels.stakeholderName,
      this.labels.initialRisk,
      this.labels.initialZone,
      this.labels.residualRisk,
      this.labels.residualRiskExpression,
      this.labels.residualZone,
      this.labels.reduction,
    ];

    const rows = this.residualRisks
      .map((r) =>
        this.createDataRow([
          `<strong>${r.stakeholderName || ""}</strong>`,
          r.initialRisk.toFixed(2),
          r.initialZone || "\u2014",
          (Number(r.residualRisk) || 0).toFixed(2),
          r.residualRiskExpression || "",
          r.residualZone || "\u2014",
          `-${r.reduction}%`,
        ]),
      )
      .join("");

    return (
      this.createSectionHeader(this.labels.residualRiskSection, 7) +
      this.createTableHeader(headers) +
      rows
    );
  }

  generateHtml() {
    const sections = [this.generateMeasuresSection(), this.generateResidualRiskSection()];

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
    table { border-collapse: collapse; width: 100%; font-family: Calibri, Arial, sans-serif; }
    tr:nth-child(even) td { background-color: #F8FAFC; }
    tr:hover td { background-color: #EFF6FF; }
    tr { page-break-inside: avoid; }
</style>
</head>
<body>
<table>
${sections.join("\n\n")}
</table>
</body>
</html>`;
  }

  download(filename) {
    const htmlContent = this.generateHtml();
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }
}

export default Workshop3Activite4CsvGenerator;
